<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <section
      v-if="show"
      class="upgrade-alert card"
    >
      <header class="upgrade-alert__header">
        <h3 class="upgrade-alert__title">
          <dr-icon
            class="upgrade-alert__icon"
            color="#CCAC66"
            name="exclamation"
          />

          Aviso de alteração em nossos planos
        </h3>

        <button
          class="upgrade-alert__close btn btn-clear modal-form__close"
          @click.prevent="closeNotification"
        >
          <dr-icon
            class="upgrade-alert__icon"
            color="#CCAC66"
            name="close"
          />
        </button>
      </header>

      <p class="upgrade-alert__text">
        Recentemente, atualizamos nossos planos disponíveis e nossa política de assinaturas.
        Por essa razão e como forma de agradecimento pelo seu longo relacionamento com o
        Dr. Conecta, migramos seu plano anterior (Gratuito) para o nosso plano PREMIUM
        gratuitamente, o atual plano mais completo da nossa plataforma.

        <strong>
          Nenhuma ação é necessária de sua parte. Já atualizamos sua conta
          em nosso banco de dados.
        </strong>
      </p>
    </section>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

const KEY_NAME = 'hasViewedUpgradeAlert'

export default {
  name: 'PlansUpgradeAlert',

  data () {
    return {
      hasViewed: true
    }
  },

  computed: {
    ...mapGetters({ plan: 'getPlan' }),

    show () {
      return !this.hasViewed && this.plan.isUpgrade
    }
  },

  created () {
    this.hasViewed = localStorage.getItem(KEY_NAME) || false
  },

  methods: {
    closeNotification () {
      localStorage.setItem(KEY_NAME, true)
      this.hasViewed = localStorage.getItem(KEY_NAME)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.upgrade-alert {
  @apply mb-4 mx-6 p-3 block;
  background-color: #FFF7E7;
  border-color: #FFD780;

  &__header {
    @apply flex flex-row items-center justify-start;
  }

  &__title {
    @apply uppercase flex flex-row items-center justify-start;
    color: #CCAC66;
    font-family: $font1;
    font-size: 0.75rem;
    font-weight: 550;
  }

  &__close {
    align-self: flex-start;
    margin-left: auto;
  }

  &__icon {
    @apply mr-1;
    height: 1rem;
    width: 1rem;
  }

  &__text {
    @apply m-0 px-4;
    font-size: 0.7rem;
  }
}
</style>
